/* eslint-disable no-unused-vars */
import slick from 'slick-carousel';

export default () => {

  const fullWidthSlider = $('.full-width-slider-slick[data-slider="true"]');

  if (fullWidthSlider.length) {

    fullWidthSlider.slick({
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      fade: true,
      cssEase: 'ease-in-out',
      speed: 750
    });

  }

};